// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getUsers = createAsyncThunk(
	"mainPages/users/getUsers",
	createApiCall(
		async (
			{
				apiParams,
				useUrl,
				infinityScroll,
				locationMd5Hash,
				isAuth,
				isTest,
				userAgent,
				isNode,
			},
			client,
		) => {
			const response = await client.post(
				`/datezone/search${
					useUrl ? "-url" : isAuth ? "" : "/unauthorized"
				}${apiParams?.limit ? `?limit=${apiParams?.limit}` : ""}`,
				{
					page: apiParams.page,
					sort: apiParams.sort,
					age_min: apiParams.age_min,
					age_max: apiParams.age_max,
					sex: apiParams.sex,
					sex_couple_1: apiParams.sex_couple_1,
					sex_couple_2: apiParams.sex_couple_2,
					country: apiParams.country,
					region: apiParams.region,
					city: apiParams.city,
					distance: apiParams.distance,
					only: apiParams.only,
					s_sex: apiParams.s_sex,
					s_age: apiParams.s_age,
					for: apiParams.s_for,
					language: apiParams.language,
					height_min: apiParams.height_min,
					height_max: apiParams.height_max,
					figure: apiParams.figure,
					zodiac: apiParams.zodiac,
					hair: apiParams.hair,
					relationship: apiParams.relationship,
					kids: apiParams.kids,
					drinking: apiParams.drinking,
					smoking: apiParams.smoking,
					education: apiParams.education,
					preference: apiParams.preference,
					name: apiParams.name,
					view_type: apiParams.view,
				},
				{
					headers: {
						Accept: "application/api.1.2+json",
						"Datezone-Research": isTest
							? Buffer.from(
									JSON.stringify({
										addua: 1,
										city: apiParams.city,
										page: apiParams.page,
										ua: userAgent || "empty",
										typ: isNode ? 2 : 1,
									}),
								).toString("base64")
							: undefined,
					},
				},
			);
			return {
				data: response.data,
				counters: response.counters,
				infinityScroll,
				locationMd5Hash,
			};
		},
	),
	{
		getPendingMeta: ({ arg }) => {
			return {
				infinityScroll: arg.infinityScroll,
			};
		},
	},
);

// ############################################################
